import angular from 'angular';
import ngMessages from 'angular-messages';
import common from '../common';

import shift from './shift';
import day from './day';
import week from './week';
import schedule from './schedule';
import driver from './driver';
import driverlist from './driverlist';
import weekselector from './weekselector';
import dailyview from './dailyview';
import driverview from './driverview';
import planner from './_planner';

// Create module
const plannerMgmt = angular.module('plannerMgmt', [
    ngMessages,
    common
]);

// Register component directives
plannerMgmt.directive('shift', shift);
plannerMgmt.directive('day', day);
plannerMgmt.directive('week', week);
plannerMgmt.directive('schedule', schedule);
plannerMgmt.directive('driver', driver);
plannerMgmt.directive('driverlist', driverlist);
plannerMgmt.directive('weekselector', weekselector);
plannerMgmt.directive('dailyview', dailyview);
plannerMgmt.directive('driverview', driverview);
plannerMgmt.config(planner);

// Export module name
export default plannerMgmt.name;



// WEBPACK FOOTER //
// ./src/js/components/planner/index.js